<template>
</template>

<script>
    import accountService from '../../services/account';
    import mixin from '../../mixins/mixin';

    export default {
        name: 'Unlock',
        mixins: [mixin],
        mounted() {
          this.unlockUser();
        },
        methods: {
          unlockUser() {
            if (this.$route.params.email) {
              accountService.unlockUser(this, this.$route.params.email);
            }
          }
        }
      }
</script>



// WEBPACK FOOTER //
// Unlock.vue?a2f5cf9e